import BasicAutoQueryController from "servicestack/auto-query/auto-query.controller";
import filters from "webforms/formio/formio-container.filters";
import sortOptions from "webforms/formio/formio-container.sort-options";
import labels from "webforms/formio/_labels";
import Formio from "webforms/formio/formio.model";
import FormSubmissionPrompt from "webforms/formio/formio-submission-prompt";

export default class FormioContainerController extends BasicAutoQueryController {
	constructor() {
		super();
		const $ctrl = this;
		$ctrl.ngModel = this;
		$ctrl.labels = labels;
		$ctrl.mode = "medium";
	}

	getQuery() {
		const $ctrl = this;
		return {
			url: `QueryFormConfigs.json?Fields=Id,Label,Description,Euid,Active`,
			disableQueryString: !!$ctrl.disableQueryString,
			pageSize: 12,
			criteria: {},
			filters,
			hideLeftNav: true, // $ctrl.$pageConfig.is('gt-sm'),
			autoLoad: true,
			sortOptions,
			scrub(res) {
				res.data.results = res.data.results.map((formio) => new Formio(formio));
			},
			onLoaded: (args) => $ctrl.onFormiosLoaded(args),
		};
	}

	$delete(formConfig) {
		const $ctrl = this;
		return modals
			.confirm("Are you sure?", "Delete Form")
			.result.then(function () {
				$ctrl.query.bus
					.send("DeleteFormConfig.json", formConfig)
					.then(function (response) {
						$ctrl.query.load(true);
					});
			});
	}

	createSubmission(formio) {
		const $ctrl = this;
		return FormSubmissionPrompt({
			formio,
			title: formio.label,
		}).then(() => $ctrl.query.load(true));
	}

	onFormiosLoaded(args) { }
}
